import React, { ElementType } from 'react';
import { Theme } from '../../interfaces/enums/Theme.enum';

export const withBlokWrapper = (
  Component: ElementType,
  theme?: Theme,
  tailwindHeightClassOverride?: string,
  tailwindWidthClassOverride?: string
) => {
  /*-- can we improve on this? investigation underway --*/

  return (props: any) => {
    return (
      <div
        id={props?.blok?._uid || ''}
        data-theme={theme || props?.blok?.theme || props?.theme || Theme.LIGHT}
        className={`bg-surface/background ${
          tailwindHeightClassOverride || 'h-[inherit]'
        } ${tailwindWidthClassOverride || 'w-[inherit]'}`}
      >
        <Component {...props} />
      </div>
    );
  };
};
